import { Component, Input ,Output,EventEmitter,OnInit, AfterViewInit,AfterViewChecked} from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, Validators } from '@angular/forms';
import { callbackify } from 'util';
declare var $ : any;
import * as moment from 'moment';


@Component({
  selector: 'ngbd-modal-content',
  styleUrls:['./modal1.css'],
  templateUrl:'./modal1.component.html'
  
})
export class NgbdModalContent  implements AfterViewInit,OnInit {
 
  @Input() year;
  @Input() month;
  @Input() newsletterI;
 
  inputControl:any;

  max_length:number=25;


  
  @Output() passEntry: EventEmitter<any> = new EventEmitter();

  public newsletter={
       name:'',
       publish:'',
       deadline:'',
       number:'',
       description:'',
       invite:[]
  };

  constructor(public activeModal: NgbActiveModal) {


 

  }

 
  onKeydownEvent($evt){

    

    return ($evt.target.value.length < this.max_length)? true:false;

  }

  passBack() {
      
      this.passEntry.emit(this.newsletter);
      
    }

    ngOnInit(){

        
    
      
      if(this.newsletterI!=undefined) {
              
        this.newsletter =this.newsletterI;

        $('.specific input').addClass('value-exists');

  

      }     

        
    }

 

    ngAfterViewInit(): void {
      //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
      //Add 'implements AfterViewInit' to the class.
 

   
       


       var ct =  this.year+"-"+this.month+"-"+"01";

       var cty=  this.year+"-"+this.month+"-";
 
       var begin = moment().format(ct);

       var yy =this.year+'-'+this.month;

       var end =  moment().format(cty) + moment(yy, "YYYY-MM").daysInMonth();

 
       
       function enumerateDaysBetweenDates(startDate, endDate,rejectDate) {
        startDate = moment(startDate);
        endDate = moment(endDate);

        if(rejectDate!=''){
          rejectDate = moment(rejectDate);
        }    
    
        var now = startDate, dates = [];
    
        while (now.isBefore(endDate) || now.isSame(endDate)) {
          
             if(rejectDate!=''){

              if(!now.isSame(rejectDate)){

                dates.push(now.format('YYYY-MM-DD'));

              }            

             } else{

                dates.push(now.format('YYYY-MM-DD'));
             }

           
            now.add(1, 'days');
        }
        return dates;
    };

    var disabledDates =[];

     if(this.newsletter.publish !=''){

       disabledDates =enumerateDaysBetweenDates(begin, moment().subtract(1, 'day').format('YYYY-MM-DD'),moment(this.newsletter.publish,"YYYY-MM-DD"));

     } else{

       disabledDates =enumerateDaysBetweenDates(begin, moment().subtract(1, 'day').format('YYYY-MM-DD'),'');

     }
    


    var disabled =  disabledDates;

   
 
      $('.datepicker1').datepicker({
        
     
      
         autoclose: true,
         format: "yyyy-mm-dd",
         startView: "date", 
         minViewMode: "date",
         startDate: begin,  
         endDate: end,  
        //  datesDisabled: end,

        datesDisabled: disabled,

         beforeShowDay: function(date) {

          
           
          var i = disabled.findIndex( (d)=> {return d==moment(date,'YYYY-MM-DD').format('YYYY-MM-DD') ;});

         

          if(i !=-1){

            return {classes: 'old disabled'};
          }



        

           if(this.newsletter.publish!=''){


            var x = moment(date,"YYYY-MM-DD");

            if(x.isSame( moment(this.newsletter.publish,"YYYY-MM-DD") )){

            

              return {classes: 'active highlight'};

            }

           }
   
         
        

    


           
       

  
       }.bind(this),

      
       
    }).on('changeDate', function(e) {
 
      
        // this.callback(e.format());

 

         this.newsletter.publish =e.format();
           
      

  
         $('.datepicker1').addClass('value-exists')

        // important line 
        
         $('.datepicker1').datepicker('update');


         
         
    }.bind(this));



    

 
   

    
    $('input').not('.datepicker1').blur(function(event) {
      var inputValue = this.value;
      if (inputValue) {
        this.classList.add('value-exists');
      } else {
        this.classList.remove('value-exists');
      }
    });
        
      
    }
}